import { UIHeading4, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './MortgageOffersNotFound.css';

interface IMortgageOffersNotFoundProps {
  mortgageUrl: string;
}

export const MortgageOffersNotFound: React.FC<React.PropsWithChildren<IMortgageOffersNotFoundProps>> = ({
  mortgageUrl,
}) => {
  return (
    <div className={styles['container']} data-testid="MortgageOffersNotFound">
      <div className={styles['image']} />
      <div className={styles['title']}>
        <UIHeading4 color="text-primary-default">Нет подходящих предложений от банков и застройщиков</UIHeading4>
      </div>
      <UIText2 color={'gray60_100'} textAlign={'center'}>
        Воспользуйтесь предложениями от{' '}
        <a className={styles['link']} href={mortgageUrl} target="blank" rel="noreferrer">
          Циан.Ипотеки
        </a>
      </UIText2>
    </div>
  );
};
